<template>
	<div class="p_box" id="box">
		<div id="head">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/Homes' }" replace>首页</el-breadcrumb-item>
				<el-breadcrumb-item>个人信息</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="mine_list p_m_t_30 overflow small_hand" :style="{ height: height + 'px' }">
			<div class=" user_box ">
				<span class="type_size_22">{{userData.name}}</span>
				<div class="p_m_t_20"><el-tag type="success" effect="dark" size="small">{{userData.classLevel?userData.classLevel.name:''}}</el-tag></div>
				<div class="p_flex p_f_a p_f_b p_m_t_30">
					<span class="type_size_20">修改密码</span>
					<el-button  @click='goPassword' type="success" size="small" plain>修改</el-button>
				</div>
				<div class="p_flex p_f_b p_m_t_30">
					<span class="type_size_20">绑定手机号</span>
					<div class="p_flex p_f_a">
						<span class="p_m_r_30" v-if="userData.phone">{{userData.phone.substr(0,3)}}****{{userData.phone.substr(7,11)}}</span>
						<span class="p_m_r_30" v-else >未绑定</span>
						<el-button @click='goMobile' type="success" size="small" plain>修改</el-button>
					</div>
				</div>
				<div class="p_flex p_f_b p_f_a p_m_t_30" @click="goSetting">
					<span class="type_size_20">设置密保</span>
					<el-button type="success" size="small" plain>设置</el-button>
				</div>
			</div>
		</div>
		<user-password :isPassword='password' @closesp='closesp' @goButtonp='goButtonp'></user-password>
		<user-mobile :mobile="mobile" @closesm='closesm' @goButtonp='goButtonm'></user-mobile>
	</div>
</template>

<script>
import UserPassword from './commponents/password.vue'
import UserMobile from './commponents/mobile.vue'
export default {
	name: 'Users',
	components:{
		UserPassword,
		UserMobile
	},
	data() {
		return {
			height: 0,
			password:false,
			mobile:false,
			userData: {},
		};
	},
	mounted() {
		this.indexInfo();
		this.getUserInfo()
	},
	watch: {
		'$route.path': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == '/Users') {
					var height = localStorage.getItem('height');
					if (height == '') {
					} else {
						this.height = height;
					}
				}
			}
		}
	},
	beforeRouteLeave(to, form, next) {
		localStorage.removeItem('height');
		next();
	},
	methods: {
		indexInfo() {
			var box = document.getElementById('box').offsetHeight;
			var head = document.getElementById('head').offsetHeight;
			var height = box - head - 30;
			var heights = localStorage.getItem('height');
			if (heights == null) {
				localStorage.setItem('height', height);
			} else {
			}
			this.height = height;
		},
		getUserInfo(){
			this.$request.ajax(this).post('api/login_info').then(res=>{
				this.userData = res.data
			})
		},
		goSetting(){
			this.$router.push('/Settings');
		},
		goPassword(){
			this.password = true
		},
		closesp(val){
			this.password = val
		},
		goButtonp(val){
			this.password = val
		},
		goMobile(){
			this.mobile = true
		},
		closesm(val){
			this.mobile = val
		},
		goButtonm(val){
			this.mobile = false
			this.getUserInfo()
		}
	}
};
</script>

<style lang="scss" scoped>
.mine_list {
	background: #ffffff;
}
.user_box {
	padding: 30px 260px;
}
>>> .el-tag--dark.el-tag--success {
	background-color: #00af63;
	border-color: #00af63;
}
</style>



// WEBPACK FOOTER //
// src/components/homes/user/index.vue